import { notification } from 'antd';
import { call, debounce, put } from 'redux-saga/effects';

import { DEFAULT_DEBOUNCE_DELAY } from '#constants';
import RequestLogService from '#services/RequestLogService';

import { getRequestLogs, setLoading, setRequestLogs } from './';

function* getRequestLogsList({ payload }) {
  try {
    yield put(setLoading(true));
    const logs = yield call(RequestLogService.getList, payload);
    yield put(setRequestLogs({ ...logs, page: payload?.page }));
  } catch (error) {
    notification.error({ message: error?.response?.data?.error?.message });
    yield put(setRequestLogs({ count: 0, page: 1, result: [] }));
    yield put(setLoading(false));
  }
}

function* RequestLogsSaga() {
  yield debounce(
    DEFAULT_DEBOUNCE_DELAY,
    getRequestLogs.type,
    getRequestLogsList
  );
}

export default RequestLogsSaga;
